import { useTranslation } from 'react-i18next'

const ProductSpecialOrderText = () => {
  const { t: translate } = useTranslation('common')
  return (
    <div className="bg-brand-bggray p-4">
      <p className="text-brand-black font-sofia  text-md">
        {translate('text-special-order')}
      </p>
    </div>
  )
}

export default ProductSpecialOrderText
